// extracted by mini-css-extract-plugin
module.exports = {"freeCell":"FreeCell_freeCell__3bwDx","suggested":"FreeCell_suggested__3vvdd","highlighted":"FreeCell_highlighted__3H19j"};